var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.columns, function (column) {
      return _c(
        "div",
        {
          key: column.uuid,
          class: [
            "tile is-parent",
            "" + (column.spacing ? "is-" + column.spacing : ""),
            "" + (column.spacing ? "d-print-" + column.spacing : ""),
          ],
        },
        [
          _c("column", {
            staticClass: "tile is-child",
            attrs: {
              details: column,
              "hospital-id": _vm.hospitalId,
              "listing-id": _vm.listingId,
              "organisation-id": _vm.organisationId,
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }